import React from 'react';
import emailjs from 'emailjs-com';
import { useHistory } from 'react-router-dom';

const Contact = () => {
    // router hook
    const history = useHistory();

    const handleSubmit = (e) => {
        e.preventDefault();
        emailjs.sendForm(
            'service_e1uli0s',
            'template_ou6v3l8',
            e.target,
            'user_oLAQyIiDUMCLgPv6TO01C')
            .then(res => {
                if (res.status) {
                    history.push('/');
                }
            })
            .catch(err => console.log(err))
    };

    return (
        <section className='py-12 md:pt-5 h-screen d-flex justify-content-center'>
            <div>
                <h1 className='text-center text-3xl font-bold mt-8 text-gray-800'>Contact me</h1>
                <form onSubmit={handleSubmit} className='mx-auto mt-5 md:w-1/2 w-11/12 grid'>
                    <div>
                        <label className='mb-0.5 font-bold' htmlFor='first-name'>First Name:</label>
                        <input className='block w-full p-1 rounded outline-none mb-2' type='text' id='first-name' name='firstName' required />
                        <label className='mb-0.5 font-bold' htmlFor='last-name'>Last Name:</label>
                        <input className='block w-full p-1 rounded outline-none mb-2' type='text' id='last-name' name='lastName' required />
                        <label className='mb-0.5 font-bold' htmlFor='email' >Email:</label>
                        <input className='block w-full p-1 rounded outline-none mb-2' type='email' id='email' name='email' required />
                    </div>
                    <div>
                        <label className='mb-0.5 font-bold' htmlFor='message'>Message:</label>
                        <textarea style={{ "resize": "none" }} rows="8" cols="50" className='block w-full p-1 rounded outline-none mb-2' type='textarea' id='email' name='message' required>
                        </textarea>
                    </div>
                    <button className='mt-2 rounded py-1 px-2 border border-green-600 text-green-600 hover:bg-green-600 hover:text-gray-300' type='submit'>Submit</button>
                </form>
            </div>
        </section>
    )
}

export default Contact;
